import { useTranslate } from 'module/hooks/use-translation';
import { faPlus, faSignal } from '@fortawesome/pro-solid-svg-icons';
import { useNavigate } from '@rocketlane/rocket-router';
import { EmptyState, Icon } from '@rocketlane/ui';
import React from 'react';
import { ROUTE_PATHS } from 'routes/route-paths';
import styled from 'styled-components';

export type SignalsV2SignalPermissions = {
  canRead: boolean;
  canWrite: boolean;
  canDelete: boolean;
};

export function getSignalsV2CanCreateSignal(
  signalPermissions?: SignalsV2SignalPermissions,
): boolean {
  if (signalPermissions === undefined) {
    return true;
  }

  return Boolean(signalPermissions.canWrite);
}

const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-width: 100%;
  min-height: min(70vh, 36rem);
  padding: var(--spacing-09) var(--spacing-08);
  background-color: var(--background-primary);
  box-sizing: border-box;
`;

type AccountEmptyKind = 'no_configs' | 'no_signals';

interface SignalsV2AccountEmptyStateProps {
  kind: AccountEmptyKind;
  canCreateSignal: boolean;
}

export const SignalsV2AccountEmptyState: React.FC<
  SignalsV2AccountEmptyStateProps
> = ({ kind, canCreateSignal }) => {
  const translate = useTranslate();
  const navigate = useNavigate();

  if (kind === 'no_configs') {
    return (
      <Root>
        <EmptyState
          icon={{ icon: faSignal }}
          message={translate('accounts.signal.empty.no_configurations.title')}
          description={
            canCreateSignal
              ? translate('accounts.signal.empty.no_configurations.description')
              : translate(
                  'accounts.page.signals_v2.empty_state.no_permission_create_signals',
                )
          }
          primaryAction={
            canCreateSignal
              ? {
                  leftIcon: <Icon icon={faPlus} size=".75x" />,
                  onClick: () =>
                    navigate(
                      `/${ROUTE_PATHS.AGENT_BUILDER}/${ROUTE_PATHS.SIGNAL_AGENTS}`,
                    ),
                  children: translate(
                    'accounts.signal.empty.no_configurations.create_signal',
                  ),
                }
              : undefined
          }
        />
      </Root>
    );
  }

  return (
    <Root>
      <EmptyState
        icon={{ icon: faSignal }}
        message={translate('accounts.signal.empty.filtered.title')}
      />
    </Root>
  );
};
